import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Text } from 'components';
import { Field, Form, Formik } from 'formik';

export const ShowBeeping = ({
  dataMain,
  selectedNote,
  validationSerial,
  handleProcess,
  validationPn,
  user,
}) => {
  const [selectStatusReincidencia, setStatusReincidencia] = useState('');
  const [serialDisabled, setSerialDisabled] = useState(true);
  const [client, setClient] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  // 🔥 refs para focar os campos
  const pnRef = useRef(null);
  const serialRef = useRef(null);

  // Validação de PN
  const handleValidationPn = async (event, setFieldValue, resetForm) => {
    if (event.key === 'Enter') {
      if (isProcessing) return;
      setIsProcessing(true);

      const data = await validationPn(event.target.value, dataMain?.[0]?.idCabec);

      if (!data) {
        resetForm();
        setIsProcessing(false);
        return;
      }

      setClient(data);
      setFieldValue('input_vincModelo', data?.[0]?.modelo);
      setSerialDisabled(false);

      // 🔥 FOCO PARA SERIAL
      setTimeout(() => serialRef.current?.focus(), 30);

      setIsProcessing(false);
    }
  };

  // Validação de Serial
  const handleValidationSerial = async (event, setFieldValue, resetForm, submitForm) => {
    if (event.key === 'Enter') {
      if (isProcessing) return;
      setIsProcessing(true);

      const serial = event.target.value;
      const serial20dig = serial.length === 24 ? serial.substring(4, 24) : serial;
      const ClienteOPV = selectedNote?.ClienteOPV.substring(0, 4).trim();
      const idCabec = dataMain?.[0]?.idCabec;

      const data = await validationSerial(idCabec, ClienteOPV, serial, serial20dig);

      if (data.status === 200) {
        setStatusReincidencia(data.response[0].IdStatusReincidencia);
        await submitForm();
      } else {
        resetForm();
        // 🔥 VOLTA PARA PN
        setTimeout(() => pnRef.current?.focus(), 30);
      }

      setIsProcessing(false);
    }
  };

  // Envio de dados ao processar
  const handleSubmit = async (values, { resetForm }) => {
    setIsProcessing(true);

    if (!values.input_serial?.trim() || values.input_serial.trim().length >= 25) {
      toast.error('Realize novamente a conferência desse SERIAL.');
      resetForm();

      // 🔥 VOLTA PARA PN
      setTimeout(() => pnRef.current?.focus(), 30);

      setIsProcessing(false);
      return;
    }

    const payload = {
      idCabec: dataMain?.[0]?.idCabec,
      idProdModelo: client?.[0]?.idProdModelo || dataMain?.[0]?.idProdModelo,
      idModelo: client?.[0]?.idModelo || dataMain?.[0]?.idModelo,
      serial: values.input_serial?.toUpperCase(),
      usuario: user.name,
      faltaPeca: values.faltaPeca,
      IdStatusReincidenciaGaia: selectStatusReincidencia,
      imei: '',
      mac: '',
      ativo: '',
      patrimonio: '',
    };

    await handleProcess(payload);
    resetForm();

    setSerialDisabled(true);

    // 🔥 APÓS PROCESSAR → FOCO NO PN
    setTimeout(() => pnRef.current?.focus(), 30);

    setIsProcessing(false);
  };

  return (
    <Formik
      initialValues={{ input_pn: '', input_serial: '', faltaPeca: false, input_vincModelo: '' }}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, resetForm, submitForm }) => (
        <Form>
          <Box mt={5}>
            <Grid container spacing={2} justifyContent='center' alignItems='center'>
              <label style={{ fontSize: '18px' }}>
                <Field type='checkbox' name='faltaPeca' style={{ width: '20px', height: '20px' }} />
                Falta de Peças
              </label>
            </Grid>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h6' style={{ paddingTop: '2rem' }}>
                Coleta de Dados
              </Typography>
            </Grid>

            <Grid item xs={12} lg={4}>
              <Field
                size='small'
                name='input_pn'
                label='PN'
                variant='outlined'
                component={Text}
                autoComplete='off'
                disabled={isProcessing}
                inputRef={pnRef} // 🔥 ref PN
                onClick={() => setFieldValue('input_pn', '')}
                onKeyDown={(event) => handleValidationPn(event, setFieldValue, resetForm)}
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <Field
                size='small'
                name='input_vincModelo'
                variant='outlined'
                component={Text}
                disabled
                autoComplete='off'
                value=''
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <Field
                size='small'
                name='input_serial'
                label='Serial'
                variant='outlined'
                component={Text}
                autoComplete='off'
                disabled={serialDisabled || isProcessing}
                inputRef={serialRef} // 🔥 ref SERIAL
                onKeyDown={(event) =>
                  handleValidationSerial(event, setFieldValue, resetForm, submitForm)
                }
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Button fullWidth name='btn_processar' disabled>
                Processar
              </Button>
            </Grid>

            <Grid item xs={12} lg={3}>
              <Button
                fullWidth
                name='btn_clear_beeping'
                onClick={() => {
                  resetForm();
                  setSerialDisabled(true);
                  pnRef.current?.focus(); // 🔥 limpar → volta PN
                }}
                style={{ display: 'none' }}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};
